import { PropTypes } from 'prop-types';
import { useState } from 'react';

export const MasterBlock = ({ title, children, color }) => {
  const [hidden, setHidden] = useState(false);

  return (
    <div className="row">
      <div className="card" style={{ minHeight: '0px' }}>
        <button
          className="card-header"
          style={{
            backgroundColor: color,
            display: 'flex',
            justifyContent: 'space-between',
            fontSize: '16px',
            minWidth: '100%',
          }}
          type="button"
          onClick={() => setHidden(!hidden)}
        >
          {title}
          <i className={hidden ? 'fa fa-plus' : 'fa fa-minus'} />
        </button>
        <div
          style={{
            display: hidden ? 'none' : 'flex',
            flexDirection: 'column',
            alignItems: 'flex-end',
          }}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

MasterBlock.propTypes = {
  title: PropTypes.string,
  color: PropTypes.string,
  children: PropTypes.any.isRequired,
};

MasterBlock.defaultProps = {
  title: 'Undefined',
  color: 'gray',
};
